import { Box, Button, FormLabel, Link, Stack, TextField, Typography, styled } from '@mui/material';

export const ImgStyled = styled('img')({
  width: '30px',
});

export const Typography1 = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.darkBlue,
  fontWeight: theme.typography.littleText.fontWeight,
  fontSize: theme.typography.button.fontSize,
  margin: '0px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '12px',
  },
}));
export const Typography2 = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.darkBlue,
  fontWeight: theme.typography.button.fontWeight,
  fontSize: theme.typography.mediumText.fontSize,
  textAlign: 'right',
  [theme.breakpoints.down('sm')]: {
    fontSize: '12px',
  },
}));

export const ContainerTypos = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
});

export const FormLabelStyled = styled(FormLabel)(({ theme }) => ({
  color: 'rgba(128, 128, 128, 1)',
  fontFamily: 'Poppins',
  fontWeight: '400',
  fontSize: '16px',
  flex: '1',
  flexDirection: 'row',
  [theme.breakpoints.down('sm')]: {
    fontSize: '12px',
  },
}));

export const ContainerSimulation = styled(Box)(({ theme }) => ({
  display: 'flex',
  position: 'relative',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: theme.palette.white.main,
  boxShadow: '0px 0px 8px rgba(61, 64, 75, 0.15)',
  borderRadius: '8px',
  width: '100%',
  maxWidth: '80%',
  padding: '3rem',
}));

export const SimulationTitleImg = styled('img')({
  height: '15px',
  width: '20px',
});

export const TextStyled = styled(Box)(({ theme }) => ({
  color: theme.palette.textLight.main,
  fontWeight: theme.typography.littleText.fontWeight,
  fontSize: { lg: '15px', md: '15px', sm: '15px', xs: '10px' },
}));

export const Button1 = styled(Button)({
  height: '60px',
  margin: '0px',
  color: 'white',
  backgroundColor: '2141aa',
  width: '100%',
  '&:hover': {
    backgroundColor: '#3f63e3',
  },
});

export const InputStyled = styled(TextField)`
  .MuiInputBase-input {
    font-size: 20px;
    color: #808080;
  }
`;

export const StarContainer = styled(Stack)({
  backgroundColor: 'rgba(90, 196, 177, 1)',
  borderRadius: '35px',
  position: 'relative',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '0px 7px',
  boxSizing: 'border-box',
  height: '37.69px',
  left: '-7.5%',
  top: '53px',
  width: '37.69px',
});

export const StarIcons = styled('img')({
  height: '16px',
  width: '16px',
  margin: '0px',
});

export const ContainerResult = styled(Box)({
  borderRadius: '8px',
  boxShadow: '0px 0px 8px rgba(61, 64, 75, 0.15)',
  backgroundColor: '#fff',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  alignContent: 'center',
  justifyContent: 'center',
  position: 'relative',
  boxSizing: 'border-box',
  width: '100%',
  top: 0,
});

export const ContainerResultText1 = styled(Box)({
  color: 'rgba(24, 40, 73, 1)',
  fontFamily: 'Poppins',
  fontWeight: '400',
  fontSize: '14px',
  letterSpacing: '1.4px',
  textTransform: 'uppercase',
});

export const ContainerResultText2 = styled(Box)({
  color: 'rgba(30, 34, 170, 1)',
  fontFamily: 'Poppins',
  fontWeight: '400',
  fontSize: '18px',
});

export const ContainerScenari = styled(Box)({
  backgroundColor: 'rgba(90, 196, 177, 0.1)',
  border: '1px solid rgba(90, 196, 177, 1)',
  boxSizing: 'border-box',
  borderRadius: '8px',
  display: 'flex',
  flexDirection: 'column',
  padding: '16px',
  width: '82%',
});

export const ContainerScenariBody = styled(Box)({
  backgroundColor: 'rgba(255, 255, 255, 1)',
  borderRadius: '8px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '10px 16px',
  boxSizing: 'border-box',
  margin: '14px 0px 0px 0px',
  width: '100%',
});

export const ContainerMessage = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  boxSizing: 'border-box',
  width: '100%',
});

export const ButtonResult = styled(Button)({
  width: '250px',
  height: '50px',
  fontSize: '15px',
  fontStyle: 'Poppins',
  textTransform: 'none',
});

export const BodyContributions = styled(Stack)(({ theme }) => ({
  width: '100%',
  maxWidth: '1380px',
  margin: ' 0 auto',
  marginTop: '26px',
  boxSizing: 'border-box',
  flexDirection: 'row',
  zIndex: 2,
  gap: '16px',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}));

export const MainBody = styled(Stack)(({ theme }) => ({
  width: '100%',
  flexDirection: 'column',
  minWidth: 'calc(30%-16px)',
  boxSizing: 'border-box',
  gap: '16px',
}));

export const ContainerForm = styled(Stack)(({ theme }) => ({
  boxSizing: 'border-box',
  backgroundColor: theme.palette.white.main,
  borderRadius: '16px',
  boxShadow: '0px 0px 16px rgba(0, 0, 0, 0.25)',
  padding: '16px 28px',
  width: '100%',
  flexDirection: 'column',
  alignItems: 'center',
  marginTop: '20px',
}));

export const BoxWrapper = styled(Box)(({ theme }) => ({
  width: '100%',
  boxSizing: 'border-box',
  display: 'flex',
  gap: '32px',
  flexDirection: 'column',
  margin: '0 auto',
}));

export const ButtonWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  [theme.breakpoints.up('md')]: {
    justifyContent: 'flex-start',
  },
}));

export const ContentBody = styled(Stack)(({ theme }) => ({
  boxSizing: 'border-box',
  width: '100%',
  minWidth: 'calc(70% - 44px)',
  height: '100%',
  backgroundColor: theme.palette.white.main,
  padding: '20px 0',
  borderRadius: '16px',
  boxShadow: '0px 0px 8px rgba(61, 64, 75, 0.15)',
}));

export const TituloContent = styled(Stack)(({ theme }) => ({
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '0px',
  boxSizing: 'border-box',
  gap: '8px',
  [theme.breakpoints.down('md')]: {
    marginTop: '-20px',
  },
}));

export const TitleHeadResult = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '10px',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

export const BoxContentScenary = styled(Box)(({ theme }) => ({
  boxSizing: 'border-box',
  borderRadius: '8px',
  display: 'flex',
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'column',
  width: '100%',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  padding: '16px',
}));

export const StageText = styled(Typography)(({ theme }) => ({
  textAlign: 'left',
  whiteSpace: 'pre-wrap',
  fontSynthesis: 'none',
  color: 'rgba(52, 120, 86, 1)',
  fontStyle: 'normal',
  fontFamily: 'Poppins',
  fontWeight: '400',
  fontSize: '14px',
  letterSpacing: '1.4px',
  textDecoration: 'none',
  textTransform: 'uppercase',
  margin: '0px',
  width: '100%',
  textTransform: 'uppercase',
  [theme.breakpoints.down('sm')]: {
    textAlign: 'center',
  },
}));

export const SimulatorFormContainer = styled(Stack)(({ theme }) => ({
  position: 'relative',
  margin: '0 auto',
  width: '90%',
  maxWidth: '1380px',
  boxSizing: 'border-box',
  flexDirection: 'column',
  zIndex: 2,
  gap: '16px',
  [theme.breakpoints.up('md')]: {
    top: 0,
  },
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    marginBottom: '20px',
  },
}));

export const SimulatorResultContainer = styled(Stack)(() => ({
  position: 'relative',
  margin: '0 auto',
  top: '20px',
  width: '90%',
  justifyContent: 'center',
  alignItems: 'center',
  '@media (min-width:900px)': {
    top: 0,
  },
}));

export const ContentFormContributions = styled(Stack)(({ theme }) => ({
  width: '90%',
  margin: ' 0 auto',
  boxSizing: 'border-box',
  flexDirection: 'column',
  zIndex: 2,
  gap: '16px',
  marginBottom: '68px',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    width: '100%',
  },
  [theme.breakpoints.up('sm')]: {},
}));
export const ContentSimulatorResult = styled(Stack)(({ theme }) => ({
  position: 'relative',
  margin: '0 auto',
  width: '90%',
  maxWidth: '1380px',
  boxSizing: 'border-box',
  flexDirection: 'column',
  zIndex: 2,
  gap: '16px',
  [theme.breakpoints.up('md')]: {
    top: 0,
  },
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    marginBottom: '20px',
  },
}));

export const Container = styled(Stack)(({ theme }) => ({
  boxSizing: 'border-box',
  backgroundColor: 'white',
  borderRadius: '16px',
  boxShadow: '0px 0px 16px rgba(0, 0, 0, 0.25)',
  padding: '32px 48px',
  width: '100%',
  flexDirection: 'row',
  gap: '16px',
  justifyContent: 'center',
  alignItems: 'center',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    padding: '32px 32px',
  },
}));

export const ChartComponent = styled(Box)(({ theme }) => ({
  width: '100%',
  maxWidth: 320,
  aspectRatio: '1 / 1',
  minHeight: 300,
  margin: '0 auto',
  position: 'relative',
  [theme.breakpoints.down('sm')]: {
    maxWidth: 300,
    minHeight: 300,
  },
}));

export const TituloContentt = styled(Stack)({
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '0px',
  boxSizing: 'border-box',
  gap: '8px',
  width: '100%',
});

export const BlueCard = styled(Stack)(({ theme }) => ({
  width: '100%',
  minHeight: '240px',
  justifyContent: 'space-around',
  backgroundColor: theme.palette.primary.blueNew,
  borderRadius: '8px',
  boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
  padding: '10px 24px',
  margin: '4px',
  height: 'auto',
}));

export const LeftColumnWrapper = styled(Stack)(({ theme }) => ({
  width: '50%',
  height: '100%',
  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
}));

export const RightColumnWrapper = styled(Stack)(({ theme }) => ({
  width: '100%',
  height: '100%',
  marginTop: '-20px',
  [theme.breakpoints.up('md')]: {
    width: '50%',
    marginTop: 0,
  },
}));

export const BackArrowContainer = styled(Stack)(({ theme }) => ({
  width: '100%',
  alignItems: 'flex-start',
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(2),
  [theme.breakpoints.up('md')]: {
    marginTop: '10px',
    marginBottom: theme.spacing(3),
  },
}));

export const MainBodyStack = styled(Stack)(({ theme }) => ({
  boxSizing: 'border-box',
  width: '100%',
  position: 'relative',
  padding: 0,
  margin: 0,
  marginTop: '14px',
  gap: 10,
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(10),
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column-reverse',
    gap: theme.spacing(2),
  },
}));

export const TitleSection = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontWeight: theme.typography.button.fontWeight,
  fontSize: theme.typography.title.fontSize,
  padding: '12px 0px 0px 0px',
  [theme.breakpoints.down('md')]: {
    fontSize: '20px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '18px',
  },
}));

export const TitleSectionInvestment = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontWeight: theme.typography.button.fontWeight,
  fontSize: theme.typography.title.fontSize,
  padding: '12px 0px 0px 0px',
  [theme.breakpoints.down('md')]: {
    fontSize: '20px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '18px',
  },
}));

export const TitleSectionWrapper = styled(Box)(({ theme }) => ({
  marginLeft: '30px',
  [theme.breakpoints.down('md')]: {
    marginLeft: 0,
    display: 'flex',
    justifyContent: 'center',
  },
}));

export const SectionTitle = styled(Box)({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const InvestmentContainer = styled(Stack)(({ theme }) => ({
  width: '90%',
  justifyContent: 'space-between',
  alignItems: 'start',
  marginBottom: 0,
}));

export const InvestmentInputStack = styled(Stack)(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.down('lg')]: {
    width: '100%',
  },
  flexDirection: 'column',
  justifyContent: 'space-between',
}));

export const InputLabelBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  marginTop: '-10px',
});

export const InvestmentLabel = styled(FormLabel)(({ theme }) => ({
  color: theme.palette.primary.dark,
  alignSelf: 'flex-start',
  marginTop: 0,
  fontSize: theme.typography.button.fontSize,
}));

export const InvestmentTextField = styled(TextField)(({ theme }) => ({
  color: theme.palette.primary.dark,
  width: '100%',
  marginTop: '0px',
}));

export const AvailableBalanceBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  fontSize: theme.typography.customButton.fontSize,
  color: theme.palette.secondary.main,
  marginTop: '4px',
  width: '100%',
}));

export const WarningBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  fontSize: theme.typography.customButton.fontSize,
  color: theme.palette.red.main,
}));

export const RechargeWrapper = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  justifyContent: 'space-around',
  width: '100%',
  marginTop: '-10px',
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    width: '100%',
  },
  [theme.breakpoints.up('md')]: {
    width: '90%',
  },
  [theme.breakpoints.up('lg')]: {
    width: '100%',
  },
}));

export const WarningMessageStack = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'start',
  width: '50%',
  marginLeft: '6px !important',
});

export const RechargeLink = styled(Link)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: theme.typography.customButton.fontSize,
  fontWeight: theme.typography.signInWelcome.fontWeight,
  textDecoration: 'none',
  [theme.breakpoints.down('sm')]: {
    fontSize: '14px',
    marginTop: '6px',
  },
}));

export const WarningIcon = styled(Box)({
  width: 16,
  height: 16,
});

export const WarningText = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.smallText.fontSize,
  whiteSpace: 'nowrap',
}));

export const CardTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: theme.typography.availableBalance.fontSize,
  [theme.breakpoints.down('md')]: {
    fontSize: theme.typography.button.fontSize,
  },
}));
export const ResponsiveTextBox = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    textAlign: 'center',
  },
}));

export const InfoText1 = styled(Typography)(({ theme }) => ({
  fontFamily: 'Poppins',
  fontWeight: theme.typography.titleText.fontWeight,
  color: theme.palette.primary.main,
  fontSize: theme.typography.availableBalance.fontSize,
  [theme.breakpoints.down('sm')]: {
    textAlign: 'center',
    fontSize: '18px',
  },
}));

export const InfoText2 = styled(Typography)(({ theme }) => ({
  fontFamily: 'Poppins',
  fontWeight: theme.typography.littleText.fontWeight,
  color: theme.palette.primary.darkBlue,
  fontSize: theme.typography.button.fontSize,
  letterSpacing: '0.8px',
  [theme.breakpoints.down('sm')]: {
    textAlign: 'center',
  },
}));

export const StyledLink = styled(Link)(({ theme }) => ({
  color: theme.palette.red.main,
  textDecoration: 'underline',
  fontWeight: theme.typography.smallText.fontWeight,
  fontSize: theme.typography.button.fontSize,
  textAlign: 'center',
  display: 'block',
  '&:hover': {
    color: theme.palette.red.main,
    textDecoration: 'underline',
  },
}));

export const DividendText = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.availableBalance.fontSize,
  fontWeight: theme.typography.littleText.fontWeight,
  color: theme.palette.primary.main,
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.button.fontSize,
  },
}));
